import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../api';

export const PaymentSuccessPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'error'>('loading');

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (!sessionId) {
      setStatus('error');
      return;
    }

    let cancelled = false;

    const pollForOrder = async () => {
      const maxAttempts = 10;
      const delayMs = 1500;

      for (let attempt = 0; attempt < maxAttempts; attempt++) {
        if (cancelled) return;
        try {
          const res = await api.get<{ id: number }>(`/orders/by-stripe-session/${encodeURIComponent(sessionId)}`);
          if (res.data?.id) {
            navigate(`/orders/${res.data.id}`, { replace: true });
            return;
          }
        } catch (err: any) {
          if (err?.response?.status !== 404) {
            setStatus('error');
            return;
          }
        }

        await new Promise(resolve => setTimeout(resolve, delayMs));
      }

      if (!cancelled) {
        setStatus('error');
      }
    };

    pollForOrder();

    return () => {
      cancelled = true;
    };
  }, [searchParams, navigate]);

  if (status === 'error') {
    return (
      <div className="main-content">
        <div className="alert alert-error">
          Something went wrong while finalizing your payment. Please check your orders or try again.
        </div>
      </div>
    );
  }

  return (
    <div className="main-content">
      <div className="alert alert-success">
        Finishing your payment, please wait…
      </div>
    </div>
  );
};

